import React, { useState } from "react";
import {
  Breadcrumb,
  Button,
  Col,
  Row,
  InputGroup,
  FormControl,
  Form,
} from "react-bootstrap";
import { PlusIcon, SearchIcon } from "../../../components/ui/icons";
import CreateQuickAlerts from "./createQuickAlerts";
import useQuickAlerts from "./useQuickAlerts";
import ListQuickAlerts from "./listQuickAlerts";
import { Link } from "react-router-dom";
import { routes } from "../../../common/constants";
import "./quickAlerts.scss";
import Modal4CreateAlert from "../../../components/modals/createAlert";
import { useSelector } from "react-redux";
import { selector as listQuickAlertsSelector } from "./listQuickAlerts/listQuickAlertsSlice";

const QuickAlerts = () => {
  const [show, setshow] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedSeverity, setSelectedSeverity] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");

  const { showModal } = useQuickAlerts();
  const { groupOptions } = useSelector(listQuickAlertsSelector);

  return (
    <>
      <div className="integration-container">
        <div className="integration-header">
          <div className="integration-header-content">
            <div className="integration-heading">Quick Alerts</div>
            <div className="integration-config-btn">
              {!show && (
                <div className="alerts-input">
                  <div className="alerts-search-input">
                    <InputGroup>
                      <FormControl
                        type="text"
                        placeholder="Search by alert title..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <InputGroup.Text id="alerts-search">
                        <SearchIcon />
                      </InputGroup.Text>
                    </InputGroup>
                  </div>

                  <Form.Select
                    className="filter-dropdown-quick-alerts"
                    value={selectedSeverity}
                    onChange={(e) => setSelectedSeverity(e.target.value)}
                  >
                    <option value="">All Severities</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </Form.Select>

                  <Form.Select
                    className="filter-dropdown-quick-alerts"
                    value={selectedGroup}
                    onChange={(e) => setSelectedGroup(e.target.value)}
                  >
                    <option value="">All Groups</option>
                    {groupOptions?.map((grp: any) => (
                      <option
                        key={grp.displayName}
                        value={grp.displayName}
                      >
                        {grp.displayName}
                      </option>
                    ))}
                  </Form.Select>

                  <Button className="buttonLight" onClick={showModal}>
                    <PlusIcon /> Configure Another Alert
                  </Button>
                </div>
              )}
            </div>
          </div>

          <Row className="align-items-center justify-content-between">
            <Col>
              <div className="integration-breadcrumb">
                <Breadcrumb>
                  <Breadcrumb.Item
                    linkAs={Link}
                    linkProps={{ to: `${routes.alerts}` }}
                  >
                    Alerts
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    Quick Alerts Configuration
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
        </div>

        <div className="integration_accordian">
          <ListQuickAlerts
            search={search}
            selectedSeverity={selectedSeverity}
            selectedGroup={selectedGroup}
          />
        </div>
      </div>

      <Modal4CreateAlert />
    </>
  );
};

export default QuickAlerts;
